import { getRangeIndexes } from '../common/index';
import { getCell, setCell, getSheetIndex, getSheet } from '../base/index';
import { importModelUpdate, setImage } from '../common/event';
import { isUndefined } from '@syncfusion/ej2-base';
/**
 * Specifies image.
 */
export class WorkbookImage {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    setImage(args) {
        const lastIndex = args.range ? args.range.lastIndexOf('!') : -1;
        const imgRange = args.range ? (lastIndex > -1) ? args.range.substring(lastIndex + 1) : args.range
            : this.parent.getActiveSheet().selectedRange;
        const sheetIdx = (args.range && lastIndex > -1) ?
            getSheetIndex(this.parent, args.range.substring(0, lastIndex)) : this.parent.activeSheetIndex;
        const indexes = getRangeIndexes(imgRange);
        const sheet = isUndefined(sheetIdx) ? this.parent.getActiveSheet() : getSheet(this.parent, sheetIdx);
        const cell = getCell(indexes[0], indexes[1], sheet);
        let oldImgData;
        const imgData = args.options;
        if (cell && cell.image) {
            oldImgData = cell.image;
            if (args.isPositionChanged) {
                for (let i = 0; i < oldImgData.length; i++) {
                    for (let j = 0; j < imgData.length; j++) {
                        oldImgData[i] = imgData[j];
                        if (document.getElementById(imgData[j].id)) {
                            args.isElementRemoved = true;
                            document.getElementById(imgData[j].id).remove();
                        }
                    }
                }
            }
            else {
                oldImgData = cell.image;
                for (let i = 0; i < imgData.length; i++) {
                    oldImgData.push(imgData[i]);
                }
            }
        }
        setCell(indexes[0], indexes[1], sheet, { image: (cell && cell.image) ? oldImgData : imgData }, true);
        return args.isElementRemoved;
    }
    updateImagesFromSheet() {
        this.parent.sheets.forEach((sheet) => {
            if (sheet.imageColl) {
                sheet.imageColl.forEach((model) => {
                    const imageModel = model;
                    const indexes = imageModel.address;
                    delete imageModel.address;
                    const cell = getCell(indexes[0], indexes[1], sheet);
                    if (cell && cell.image) {
                        cell.image.push(imageModel);
                    }
                    else {
                        setCell(indexes[0], indexes[1], sheet, { image: [imageModel] }, true);
                    }
                });
                delete sheet.imageColl;
            }
        });
    }
    /**
     * Adding event listener for number format.
     *
     * @returns {void} - Adding event listener for number format.
     */
    addEventListener() {
        this.parent.on(setImage, this.setImage, this);
        this.parent.on(importModelUpdate, this.updateImagesFromSheet, this);
    }
    /**
     * Removing event listener for number format.
     *
     * @returns {void}
     */
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(setImage, this.setImage);
            this.parent.off(importModelUpdate, this.updateImagesFromSheet);
        }
    }
    /**
     * To Remove the event listeners.
     *
     * @returns {void} - To Remove the event listeners.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    /**
     * Get the workbook number format module name.
     *
     * @returns {string} - Get the module name.
     */
    getModuleName() {
        return 'workbookImage';
    }
}
